<template lang="pug">
  .row
    .columns.large-24
      a.button.left.a-pol(v-for="registration_agreement in registration.policies()",
        @click="showPolicy(registration_agreement.agreement)") {{registration_agreement.agreement.name}}

    modal(v-if="showModal",@close="showModal = false")
      span(slot="header") {{currentPolicy.name}}
      p(slot="body",v-html="external_links($sanitize(currentPolicy.description))", v-linkified="")
</template>
<script>
import modal   from 'templates/shared/modal'
export default {
  name: "policies",
  components: {modal},
  data (){
    return {
      policy: {},
      currentPolicy: {},
      showModal: false
    }
  },
  methods: {
    showPolicy(pol){
      this.currentPolicy = pol;
      this.showModal = true
    },
  },
  computed: {
      registration(){
        return this.state.current_reg
      },
  },
}
</script>
<style scoped>
  .a-pol{
    margin: 5px;
  }
</style>
